import { Amplify, type ResourcesConfig } from 'aws-amplify';

// Cognito pool configuration
// For now, admin uses the same pools as web dashboard
// TODO: Create dedicated admin Cognito pool with admin-specific groups
type Environment = 'local' | 'dev' | 'prod';

interface CognitoConfig {
  userPoolId: string;
  userPoolClientId: string;
  region: string;
}

const cognitoConfigs: Record<Environment, CognitoConfig> = {
  local: {
    // haulkeep-local pool (for local development and E2E tests)
    userPoolId: 'us-east-2_Fu4r5rODC',
    userPoolClientId: '153o361lu1227lp4511kv8fr12',
    region: 'us-east-2',
  },
  dev: {
    // haulkeep-dev pool (for AWS dev environment)
    userPoolId: 'us-east-2_Ftb17x2cF',
    userPoolClientId: '29e6e17u6edbld89k9qieo1ct0',
    region: 'us-east-2',
  },
  prod: {
    // Production pool (to be configured)
    userPoolId: '',
    userPoolClientId: '',
    region: 'us-east-2',
  },
};

function getEnvironment(): Environment {
  const envOverride = import.meta.env.VITE_API_ENV as Environment | undefined;
  if (envOverride && envOverride in cognitoConfigs) {
    return envOverride;
  }
  return import.meta.env.DEV ? 'local' : 'prod';
}

const env = getEnvironment();
const cognitoConfig = cognitoConfigs[env];

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
    },
  },
};

export function configureAmplify(): void {
  Amplify.configure(amplifyConfig);
}

export function getAuthConfig() {
  return {
    environment: env,
    ...cognitoConfig,
  };
}
